import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import Carousel from '@sdk/components/ui/Carousel';
import H3 from '@sdk/components/ui/typography/H3';
import Text14 from '@sdk/components/ui/typography/Text14';

export const Container = styled(Column)`
  flex: 1;
`;

export const CarouselFlex = styled(Carousel)`
  flex: 1;

  > div:last-child {
    padding: 0 20px 20px 20px;
    margin-top: 0;

    // Circle portion of slide buttons
    & svg circle {
      fill: none;
    }

    // Arrow stroke of slide buttons
    & svg path:not([fill-rule]) {
      stroke: ${(props) => props.theme.colors.iconGray};
    }

    // Override opacity of deactivated button on first or last slide
    & svg g[opacity='0.15'] {
      opacity: 0;
    }
  }
`;

export const TextLine = styled.span`
  text-align: center;
`;

export const ScheduleImage = styled.img`
  width: 620px;
`;

export const VideoWrapper = styled(Row)`
  position: relative;
  > iframe {
    border-width: 0;
    border-radius: 8px;
  }
`;

export const VideoOpener = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.01);
  }
`;

export const BoldHeader = styled(H3)`
  font-weight: bold;
  color: ${(props) => props.theme.colors.primaryText};
`;

export const ModalText = styled(Text14)`
  text-align: center;
  color: ${(props) => props.theme.colors.gray};
`;

export const ScheduleImportButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  text-justify: auto;
  justify-content: center;
  width: 205px;
  height: 36px;
  color: white;
  background: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  border-radius: 4px;
`;

export const CloseModalButtonWrapper = styled.div`
  z-index: 20;
  top: 10px;
`;

export const BuildMyOwnScheduleButton = styled(Text14)`
  cursor: pointer;
  color: ${(props) => props.theme.colors.iconGray};
`;

export const SingleCardModalContainer = styled.div`
  padding-bottom: 56px;
  padding-left: 20px;
  padding-right: 20px;
`;
